import React from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import { Formik, Form, } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
  changeUserPassword,
  clearBuyerMessages,
} from "../../../features/user/userSlice";
import { showAppMessageToast } from "../../../utils/toastUtils";

// Yup validation schema
const passwordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current password is required"),
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New password is required"),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm your new password"),
});

const ChangePasswordTab = () => {
  const dispatch = useDispatch();
  const handleSavePassword = (values, { resetForm }) => {
    const payload = {
      current_password: values.currentPassword,
      new_password: values.newPassword,
      new_password_confirmation: values.confirmNewPassword,
    };

    dispatch(changeUserPassword(payload))
      .unwrap()
      .then(() => {
        showAppMessageToast({
          type: "success",
          title: "Password Changed",
          message: "Your password has been updated successfully.",
        });
        resetForm();
        setTimeout(() => dispatch(clearBuyerMessages()), 3000);  
      })
      .catch((err) => {
        showAppMessageToast({
          type: "error",
          title: "Password Change Failed",
          message: err || "Something went wrong. Please try again.",
        });
        setTimeout(() => dispatch(clearBuyerMessages()), 3000);
      });
  };

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          maxWidth: 500,
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
          Change Password
        </Typography>

        <Formik
          initialValues={{
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
          }}
          validationSchema={passwordSchema}
          onSubmit={handleSavePassword}
        >
          {({ errors, touched, handleChange, values }) => (
            <Form
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <TextField
                label="Current Password"
                type="password"
                name="currentPassword"
                value={values.currentPassword}
                onChange={handleChange}
                error={
                  touched.currentPassword && Boolean(errors.currentPassword)
                }
                helperText={touched.currentPassword && errors.currentPassword}
                variant="outlined"
              />
              <TextField
                label="New Password"
                type="password"
                name="newPassword"
                value={values.newPassword}
                onChange={handleChange}
                error={touched.newPassword && Boolean(errors.newPassword)}
                helperText={touched.newPassword && errors.newPassword}
                variant="outlined"
              />
              <TextField
                label="Confirm New Password"
                type="password"
                name="confirmNewPassword"
                value={values.confirmNewPassword}
                onChange={handleChange}
                error={
                  touched.confirmNewPassword &&
                  Boolean(errors.confirmNewPassword)
                }
                helperText={
                  touched.confirmNewPassword && errors.confirmNewPassword
                }
                variant="outlined"
              />
              <Button
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: "scraptradeYellow.main",
                  "&:hover": { bgcolor: "scraptradeYellow.dark" },
                  px: 3,
                  alignSelf: "flex-end",
                  width: "auto",
                }}
              >
                Update Password
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default ChangePasswordTab;
